export enum AUTH_TYPES {
  Google = 'google',
  Github = 'github',
}

export type REGISTRATION_STEPS = 1 | 2 | 3

export const POPUP_HEIGHT = 700
export const POPUP_WIDTH = 600
